module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav-tablet",
    class: _vm.classList
  }, [_c('div', {
    staticClass: "nav-tablet__container"
  }, [_c('div', {
    staticClass: "nav-tablet__row"
  }, [_c('div', {
    staticClass: "nav-tablet__logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "logo-color"
    }
  })], 1)], 1), _c('a', {
    staticClass: "nav-tablet__phone-button",
    attrs: {
      "href": _vm.props.links.phone_link
    }
  }, [_c('Icon', {
    attrs: {
      "name": "phone"
    }
  })], 1)]), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollingUp),
      expression: "scrollingUp"
    }],
    staticClass: "nav-tablet__row"
  }, [_c('div', {
    staticClass: "nav-tablet__navbar"
  }, _vm._l((_vm.links), function(nav, i) {
    return (nav.navigation) ? _c('span', {
      key: i,
      staticClass: "nav-tablet__link"
    }, [_c('router-link', {
      attrs: {
        "to": nav.path
      }
    }, [_vm._v(_vm._s(nav.linkName) + "           ")])], 1) : _vm._e()
  }))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-713f4be7","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/nav-tablet/nav-tablet.pug
// module id = 573
// module chunks = 1